import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from '../../dynamicComponent';
import {InlineTextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {isFemaUser} from 'common/utils';
import _ from 'lodash';

/* Table for listing regional participating agencies */
export class ParticipatingAgenciesTable extends React.Component {
  state = {
    data: [{}],
  };

  componentDidUpdate(prevProps) {
    this.refreshState(prevProps);
  }

  componentDidMount() {
    this.refreshState();
  }

  refreshState(prevProps) {
    const {numberOfRows, data, maxRowSize, readOnly} = this.props;
    if (
      !_.isEqual(data, _.get(prevProps, 'data')) ||
      !_.isEqual(numberOfRows, _.get(prevProps, 'numberOfRows'))
    ) {
      const newNumberOfRows =
        numberOfRows > maxRowSize ? maxRowSize : numberOfRows > 1 ? numberOfRows : 1;
      let newData = [];
      for (let x = 0; x < newNumberOfRows; x++) {
        newData[x] = _.get(data, x, {});
      }
      this.setState({data: newData});
    }
  }

  handleBlur = (e) => {
    const {saveEntityData, entityType, entityDataPath, validationId} = this.props;
    const {data} = this.state;
    saveEntityData(
      entityDataPath,
      entityType,
      data,
      `${validationId}.${_.get(e, 'target.name')}`
    );
  };

  render() {
    const {data} = this.state;
    const {validationErrors, validationDirtyMap, readOnly} = this.props;

    const handleChange = (e) => {
      let newData = _.cloneDeep(this.state.data);
      _.set(newData, e.target.name, e.target.value);
      this.setState({
        data: newData,
      });
    };

    const findError = (errArr) => {
      let errToReturn = 0;
      for (let x = 0; x < _.size(errArr); x++) {
        if (errArr[x].isValid === false) {
          errToReturn = x;
        }
      }
      return _.get(errArr, errToReturn);
    };

    const isDirty = (index, fieldName) =>
      _.get(validationDirtyMap, 'dirtyPage', false) ||
      _.get(validationDirtyMap, ['dirty', index, fieldName], false);

    return (
      <React.Fragment>
        <p>
          Please list each participating agency by name along with a point of contact
          (POC), to include a phone number. All regional participants must be eligible as
          defined by the Notice of Funding Opportunity.
        </p>

        <FemaGoTable
          summary={'Participating agencies'}
          type="static"
          columns={6}
          withForm={false}
        >
          <FemaGoTable.Header>
            <FemaGoTable.Row key="participatingAgenciesTableHeader">
              <FemaGoTable.HeaderCell>
                Participating organization name
              </FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>POC first name</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>POC last name</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Phone number</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Phone number extension</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>EIN</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>
            {_.map(data, (agency, i) => {
              return (
                <FemaGoTable.Row>
                  <FemaGoTable.TextCell>
                    {readOnly ? (
                      <React.Fragment>{_.get(agency, 'orgName')}</React.Fragment>
                    ) : (
                      <InlineTextBoxField
                        title="Participating organization name"
                        id="orgName"
                        name={`${i}.orgName`}
                        value={_.get(agency, 'orgName')}
                        handleChange={handleChange}
                        handleBlur={(e) => this.handleBlur(e)}
                        displayError={
                          isDirty(i, 'orgName') &&
                          _.get(
                            findError(_.get(validationErrors, [0, i, 'orgName'])),
                            'isValid'
                          ) === false
                        }
                        errorMessages={_.get(
                          findError(_.get(validationErrors, [0, i, 'orgName'])),
                          'message'
                        )}
                      />
                    )}
                  </FemaGoTable.TextCell>
                  <FemaGoTable.TextCell>
                    {readOnly ? (
                      <React.Fragment>{_.get(agency, 'firstName')}</React.Fragment>
                    ) : (
                      <InlineTextBoxField
                        title="POC first name"
                        id="firstName"
                        name={`${i}.firstName`}
                        value={_.get(agency, 'firstName')}
                        handleChange={handleChange}
                        handleBlur={(e) => this.handleBlur(e)}
                        displayError={
                          isDirty(i, 'firstName') &&
                          _.get(
                            findError(_.get(validationErrors, [0, i, 'firstName'])),
                            'isValid'
                          ) === false
                        }
                        errorMessages={_.get(
                          findError(_.get(validationErrors, [0, i, 'firstName'])),
                          'message'
                        )}
                      />
                    )}
                  </FemaGoTable.TextCell>
                  <FemaGoTable.TextCell>
                    {readOnly ? (
                      <React.Fragment>{_.get(agency, 'lastName')}</React.Fragment>
                    ) : (
                      <InlineTextBoxField
                        title="POC last name"
                        id="lastName"
                        name={`${i}.lastName`}
                        value={_.get(agency, 'lastName')}
                        handleChange={handleChange}
                        handleBlur={(e) => this.handleBlur(e)}
                        displayError={
                          isDirty(i, 'lastName') &&
                          _.get(
                            findError(_.get(validationErrors, [0, i, 'lastName'])),
                            'isValid'
                          ) === false
                        }
                        errorMessages={_.get(
                          findError(_.get(validationErrors, [0, i, 'lastName'])),
                          'message'
                        )}
                      />
                    )}
                  </FemaGoTable.TextCell>
                  <FemaGoTable.TextCell>
                    {readOnly ? (
                      <React.Fragment>{_.get(agency, 'phone')}</React.Fragment>
                    ) : (
                      <InlineTextBoxField
                        title="Phone number"
                        id="phone"
                        name={`${i}.phone`}
                        value={_.get(agency, 'phone')}
                        handleChange={handleChange}
                        handleBlur={(e) => this.handleBlur(e)}
                        displayError={
                          isDirty(i, 'phone') &&
                          _.get(
                            findError(_.get(validationErrors, [0, i, 'phone'])),
                            'isValid'
                          ) === false
                        }
                        errorMessages={_.get(
                          findError(_.get(validationErrors, [0, i, 'phone'])),
                          'message'
                        )}
                      />
                    )}
                  </FemaGoTable.TextCell>
                  <FemaGoTable.TextCell>
                    {readOnly ? (
                      <React.Fragment>{_.get(agency, 'extension')}</React.Fragment>
                    ) : (
                      <InlineTextBoxField
                        title="Phone number extension"
                        id="extension"
                        name={`${i}.extension`}
                        value={_.get(agency, 'extension')}
                        handleChange={handleChange}
                        handleBlur={(e) => this.handleBlur(e)}
                        displayError={
                          isDirty(i, 'extension') &&
                          _.get(
                            findError(_.get(validationErrors, [0, i, 'extension'])),
                            'isValid'
                          ) === false
                        }
                        errorMessages={_.get(
                          findError(_.get(validationErrors, [0, i, 'extension'])),
                          'message'
                        )}
                      />
                    )}
                  </FemaGoTable.TextCell>
                  <FemaGoTable.TextCell>
                    {readOnly ? (
                      isFemaUser(this.props.permissions) ? (
                        <React.Fragment>{_.get(agency, 'ein')}</React.Fragment>
                      ) : (
                        <React.Fragment>********</React.Fragment>
                      )
                    ) : (
                      <InlineTextBoxField
                        title="EIN"
                        id="ein"
                        name={`${i}.ein`}
                        value={_.get(agency, 'ein')}
                        handleChange={handleChange}
                        handleBlur={(e) => this.handleBlur(e)}
                        displayError={
                          isDirty(i, 'ein') &&
                          _.get(
                            findError(_.get(validationErrors, [0, i, 'ein'])),
                            'isValid'
                          ) === false
                        }
                        errorMessages={_.get(
                          findError(_.get(validationErrors, [0, i, 'ein'])),
                          'message'
                        )}
                      />
                    )}
                  </FemaGoTable.TextCell>
                </FemaGoTable.Row>
              );
            })}
          </FemaGoTable.Body>
        </FemaGoTable>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
  };
};

export default connect(mapStateToProps)(connectDynamic(ParticipatingAgenciesTable));
